import script from "./PerformerProjectLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./PerformerProjectLayout.vue?vue&type=script&setup=true&lang=js"

import "./PerformerProjectLayout.vue?vue&type=style&index=0&id=d50ad2d0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d50ad2d0"]])

export default __exports__